export default "__VITE_ASSET__EVI__4nz__"